<template>
  <header class="site-header">
    <div class="container header-inner">
      <router-link class="brand" to="/" aria-label="返回首页">
        <img class="brand-logo" src="../../assets/image/logo.png" alt="GPS定位器">
      </router-link>

      <div class="header-actions">
        <nav id="site-navigation" class="nav" :class="{ 'nav-open': menuOpen }">
          <router-link
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            exact
            @click.native="menuOpen = false"
          >
            {{ item.label }}
          </router-link>
        </nav>

        <div class="language-switch notranslate" aria-label="语言切换">
          <button
            type="button"
            :class="{ active: currentLanguage === 'zh-CN' }"
            @click="setLanguage('zh-CN')"
          >
            中
          </button>
          <i></i>
          <button
            type="button"
            :class="{ active: currentLanguage === 'en' }"
            @click="setLanguage('en')"
          >
            EN
          </button>
        </div>

        <button
          class="menu-toggle"
          type="button"
          :aria-expanded="menuOpen ? 'true' : 'false'"
          aria-controls="site-navigation"
          aria-label="打开导航菜单"
          @click="menuOpen = !menuOpen"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { navItems } from '../../data/site'
import { getStoredLanguage, setStoredLanguage } from '../../i18n/localLanguage'

export default {
  name: 'SiteHeader',
  data() {
    return {
      navItems,
      menuOpen: false,
      currentLanguage: getStoredLanguage()
    }
  },
  mounted() {
    window.addEventListener('site-language-change', this.syncLanguage)
  },
  beforeDestroy() {
    window.removeEventListener('site-language-change', this.syncLanguage)
  },
  methods: {
    setLanguage(language) {
      if (this.currentLanguage === language) return

      this.currentLanguage = language
      setStoredLanguage(language)
    },
    syncLanguage(event) {
      this.currentLanguage = event.detail || getStoredLanguage()
    }
  }
}
</script>
